__webpack_require__.p = "https://verifnd-admin.epixeldev.com/";